import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TableService } from '@app/shared/services/table.service';

@Component({
  selector: 'ngx-single-lookup-filed',
  templateUrl: './single-lookup-filed.component.html',
  styleUrls: ['./single-lookup-filed.component.scss']
})
export class SingleLookupFiledComponent implements OnInit {

  @Input() column: any;
  @Input() item: any;
  @Input() filteredOptions: any;
  @Input() lookupValue: any;
  @Input() parentTableHeader: any;
  @Input() dataToPassInForm: any;
  @Input() tableName : string;
  @Input() selectedValue : any;
  @Input() unwantedFieldsInOptions : string;
  @Input() rowIndex : string;

  @Output() hoverAndClose: EventEmitter<any> = new EventEmitter();
  @Output() saveIconForFieldClicked: EventEmitter<any> = new EventEmitter();
  loadingAPI: boolean;
  dropDownText: string;
  filedValueLookup ;

  constructor( private tableService: TableService,) { }

  ngOnInit(): void {
    this.filedValueLookup = this.selectedValue;
  }

  dynamicSearch(e, field) {
    let filterKey;
    if (field.name === "dependentTask" && field.lookupTableName === "Tasks") {
      filterKey = [{ isSubtask: "No" }];
    } else {
      filterKey = 0;
    }
    if (!e.target.value) {
      this.filteredOptions[field.name] = [];
      this.loadingAPI = false;
      this.dropDownText = "Type to search";
    } else {
      let lookupVal = this.lookupValue;
      let formDataObj = {};
      this.parentTableHeader.forEach((e) => {
        if (e.type != "injectSubForm" && e.type != "lookup") {
          formDataObj[e.name] = this.dataToPassInForm[e.name];
        }
      });
      this.dynamicSearchCommonFn(field, filterKey, formDataObj, lookupVal, e);
    }
  }

  async dynamicSearchCommonFn(field, filterKey, formDataObj, lookupVal, e?) {
    this.loadingAPI = true;
    let response = await this.tableService.getDynamicTreeData(field.lookupTableName, 1, e ? e.target.value : "", 0, filterKey,
      "", "", "", this.tableName, field.name, formDataObj, lookupVal, "", "", "", "", "", "", "", "", "", "", this.item._id)

    if (response) {
      let res = response as any;
      this.filteredOptions[field.name] = [];
      if (res && res.data && res.data.pageOfItems) {
        res.data.pageOfItems.forEach((data) => {
          let val = "";
          Object.keys(data).forEach((lookupele) => {
            if (
              !!data[lookupele] &&
              !this.unwantedFieldsInOptions.includes(lookupele) &&
              lookupele != "createdAt" &&
              lookupele != "updatedAt"
            ) {
              val = val + " " + data[lookupele];
            }
          });
          const obj = {
            id: data._id,
            value: val,
          };
          this.filteredOptions[field.name] = [
            ...this.filteredOptions[field.name],
            obj,
          ];
        });
        this.loadingAPI = false;
      } else {
        this.loadingAPI = false;
      }
      if (this.filteredOptions[field.name].length) {
         this.dropDownText = "Type to search";
      } else {
         this.dropDownText = "No record found";
      }
    }
  }

  closeFun () {
    this.hoverAndClose.emit(this.rowIndex);
  }

  SaveDataFunciton(){
    this.saveIconForFieldClicked.emit({ name: this.column.name, item: this.item , filedValueLookup : this.filedValueLookup , column :  this.column });
  }

  removeSelected(val) {
    const index = this.filedValueLookup?.findIndex((f) => f === val.id);
    console.log("index", index);
    if (index !== -1) {
      this.filedValueLookup = [...this.filedValueLookup.slice(0, index), ...this.filedValueLookup.slice(index + 1)];
    }
  }


}
